import React from 'react';
import thinkingSvg from '../../assets/icons/thinking.svg';

const ThinkingIcon: React.FC<{ width?: number }> = ({ width = 16 }) => {
  return <img src={thinkingSvg} alt='Thinking' width={width} />;
};

export default ThinkingIcon;
